// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SequenceStepStatus } from "./sequence-step-status";

/**
 * One step of a sequence run, as reported in `SequenceProgress.steps`.
 */
export class SequenceStepProgress implements flatbuffers.IUnpackableObject<SequenceStepProgressT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SequenceStepProgress {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSequenceStepProgress(
    bb: flatbuffers.ByteBuffer,
    obj?: SequenceStepProgress,
  ): SequenceStepProgress {
    return (obj || new SequenceStepProgress()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSequenceStepProgress(
    bb: flatbuffers.ByteBuffer,
    obj?: SequenceStepProgress,
  ): SequenceStepProgress {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SequenceStepProgress()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  status(): SequenceStepStatus {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SequenceStepStatus.Pending;
  }

  /**
   * Milliseconds spent in this step so far, or in total once it finished.
   */
  elapsedMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * The step's timeout in milliseconds; 0 when the step has none.
   */
  timeoutMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  /**
   * Operator-facing step name: the modifier step's label, or a generated
   * description when it has none.
   */
  label(): string | null;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  label(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSequenceStepProgress(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addStatus(builder: flatbuffers.Builder, status: SequenceStepStatus) {
    builder.addFieldInt8(0, status, SequenceStepStatus.Pending);
  }

  static addElapsedMs(builder: flatbuffers.Builder, elapsedMs: number) {
    builder.addFieldInt32(1, elapsedMs, 0);
  }

  static addTimeoutMs(builder: flatbuffers.Builder, timeoutMs: number) {
    builder.addFieldInt32(2, timeoutMs, 0);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, labelOffset, 0);
  }

  static endSequenceStepProgress(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSequenceStepProgress(
    builder: flatbuffers.Builder,
    status: SequenceStepStatus,
    elapsedMs: number,
    timeoutMs: number,
    labelOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SequenceStepProgress.startSequenceStepProgress(builder);
    SequenceStepProgress.addStatus(builder, status);
    SequenceStepProgress.addElapsedMs(builder, elapsedMs);
    SequenceStepProgress.addTimeoutMs(builder, timeoutMs);
    SequenceStepProgress.addLabel(builder, labelOffset);
    return SequenceStepProgress.endSequenceStepProgress(builder);
  }

  unpack(): SequenceStepProgressT {
    return new SequenceStepProgressT(
      this.status(),
      this.elapsedMs(),
      this.timeoutMs(),
      this.label(),
    );
  }

  unpackTo(_o: SequenceStepProgressT): void {
    _o.status = this.status();
    _o.elapsedMs = this.elapsedMs();
    _o.timeoutMs = this.timeoutMs();
    _o.label = this.label();
  }

  unpackFields(...fields: string[]): SequenceStepProgressT {
    const t = new SequenceStepProgressT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("status")) {
      t.status = this.status();
    }
    if (fieldSet.has("elapsed_ms")) {
      t.elapsedMs = this.elapsedMs();
    }
    if (fieldSet.has("timeout_ms")) {
      t.timeoutMs = this.timeoutMs();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    return t;
  }
}

export class SequenceStepProgressT implements flatbuffers.IGeneratedObject {
  constructor(
    public status: SequenceStepStatus = SequenceStepStatus.Pending,
    public elapsedMs: number = 0,
    public timeoutMs: number = 0,
    public label: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const label = this.label !== null ? builder.createString(this.label!) : 0;

    return SequenceStepProgress.createSequenceStepProgress(
      builder,
      this.status,
      this.elapsedMs,
      this.timeoutMs,
      label,
    );
  }

  clone(): SequenceStepProgressT {
    const obj = new SequenceStepProgressT();
    obj.status = this.status;
    obj.elapsedMs = this.elapsedMs;
    obj.timeoutMs = this.timeoutMs;
    obj.label = this.label;
    return obj;
  }

  equals(other: SequenceStepProgressT): boolean {
    if (this.status !== other.status) return false;
    if (this.elapsedMs !== other.elapsedMs) return false;
    if (this.timeoutMs !== other.timeoutMs) return false;
    if (this.label !== other.label) return false;
    return true;
  }
}

export function verifySequenceStepProgress(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
